<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update'
  },
  props: {
    disabled: {
      type: Boolean,
      default: null
    },
    formType: {
      type: String,
      default: 'text'
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: null
    },
    labelSize: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    max: {
      type: Number
    },
    customStyle: {
      type: String,
      default: ''
    },
    baseStyle: {
      type: String,
      default: ''
    },
    prefixIcon: {
      type: String,
      default: null
    },
    suffixIcon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    changeMethod: {
      type: Function
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('update', event.target.value)
    }
  }
}
</script>

<template>
  <div
    class="base-input-question-text"
    style="
      position: relative;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    "
    :style="baseStyle"
  >
    <div
      v-if="label"
      class='input-label'
      style="
        text-align: left;
        margin-bottom: 8px;
        width: 100%;
      "
    >
      <label
        style="
          color: #333;
          font-weight: bold;
          position: relative;
        "
        :style="'font-size: ' + (labelSize ? labelSize : 14) + 'px'"
      >
        {{ label }}
      </label>
    </div>
    <md-icon
      v-if="prefixIcon"
      style="position: absolute;bottom: 10px;left: 10px;"
      :style="iconColor ? ('color: ' + iconColor) : ''"
    >
      {{ prefixIcon }}
    </md-icon>
    <span v-if="disabled" v-html="$attrs.value"></span>
    <input
    v-else
      :type="type"
      :class="$style.input"
      :style="(formType == 'filter' ? 'border-radius: 4px;' : ';') + ('padding-left: ' + (prefixIcon ? '35px' : '16px') + '; padding-right: ' + (suffixIcon ? '35px;' : '16px;')) + (disabled ? 'opacity: 0.5; cursor: not-allowed;' : '') + customStyle"
      v-bind="$attrs"
      :max="max"
      v-on="$listeners"
      @input="handleChange"
    />
    <span @click="$emit('clickSuffixIcon')">
      <md-icon
        v-if="suffixIcon"
        style="position: absolute;bottom: 10px;right: 10px; cursor: pointer"
        :style="iconColor ? ('color: ' + iconColor) : ''"
      >{{ suffixIcon }}</md-icon>
    </span>
  </div>
</template>

<style lang="scss" module>
.input {
  background: rgba(0, 0, 0, 0.05);
  // box-shadow: 0 8px 20px rgba($color: #000000, $alpha: 0.16) !important;
  border: 1px solid transparent !important;
  border-radius: 5px;
  margin: 0 !important;
  width: 100% !important;
  height: 42px !important;
}

input:disabled {
  background: rgba(0, 0, 0, 0.05) !important;
}

@media only screen and (max-width: 320px) {

}
@media only screen and (max-width: 480px) {

}
@media only screen and (max-width: 600px) {

}
@media only screen and (max-width: 768px) {

}
@media only screen and (max-width: 900px) {

}
@media only screen and (max-width: 1024px) {

}
</style>
